import { render, staticRenderFns } from "./UpdateGroup.vue?vue&type=template&id=6f5d9db6&scoped=true"
import script from "./UpdateGroup.vue?vue&type=script&lang=js"
export * from "./UpdateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d9db6",
  null
  
)

export default component.exports